import { usePrevious } from 'hooks/utils';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { StorageKeys } from 'types/index';

export function StorePrevLocation() {
	const { pathname } = useLocation();

	const prevPathname = usePrevious(pathname);
	useEffect(() => {
		if (prevPathname) localStorage.setItem(StorageKeys.PrevPathname, prevPathname);
	}, [pathname]);

	return null;
}
